import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5 21a5 5 0 015-5h8a5 5 0 015 5v2a1 1 0 11-2 0v-2a3 3 0 00-3-3h-8a3 3 0 00-3 3v2a1 1 0 11-2 0v-2zM9 9a5 5 0 1110 0A5 5 0 019 9zm5-3a3 3 0 100 6 3 3 0 000-6z" fill="#8A8175" /></svg>);